import { render, staticRenderFns } from "./playing-with-a-purpose.vue?vue&type=template&id=f8c90e62&scoped=true&"
var script = {}
import style0 from "./playing-with-a-purpose.vue?vue&type=style&index=0&id=f8c90e62&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8c90e62",
  null
  
)

export default component.exports